package dev.lingvo.site.pages.app.projects.slug.screenshots

import androidx.compose.runtime.Composable
import dev.lingvo.shared.DeviceClass
import dev.lingvo.shared.StorePlatform
import dev.lingvo.shared.screenshots.doc.FrameKind
import dev.lingvo.site.components.studio.preview.DesignLooksPort
import dev.lingvo.site.ds.LMuted
import dev.lingvo.site.ds.LSelect
import dev.lingvo.site.ds.LSelectOption
import dev.lingvo.site.i18n.t

/** Offers engine-compatible frames while retaining Google's recommendation as advice. */
@Composable
internal fun FramePicker(device: DeviceClass, frame: FrameKind, looks: DesignLooksPort, canWrite: Boolean, onChange: (FrameKind) -> Unit) {
    if (canWrite) LSelect(frame.name, looks.framesFor(device).map { LSelectOption(it.name, it.name.replace('_', ' ').lowercase()) },
        onValueChange = { raw -> looks.framesFor(device).firstOrNull { it.name == raw }?.let(onChange) },
        label = t("app.projects.slug.screenshots.frame_picker.frame", "Device frame"))
    else LMuted(frame.name.replace('_', ' ').lowercase())
    if (device.platform == StorePlatform.GOOGLE_PLAY) LMuted(t("app.projects.slug.screenshots.frame_picker.advice", "Google Play advises against device frames"))
}
